import { Card, Radio, Button, Form, DatePicker, TimePicker } from 'antd'
import { useState } from 'react'
import moment from 'moment'
import '../Style/blogStyle.scss'
import { Visibility } from 'types/blogs/blogs'

const VisibilityCard = ({ publishStatus, setPublishStatus, form, initialDateTime }: any) => {
  const [showSchedule, setShowSchedule] = useState(!!initialDateTime?.date)
  const [date, setDate] = useState(initialDateTime?.date || null)
  const [time, setTime] = useState(initialDateTime?.time || null)

  const handleScheduleClick = () => {
    setShowSchedule(true)
  }

  const handleClearDate = () => {
    setDate(null)
    setTime(null)
    setShowSchedule(false)
    form.setFieldValue('scheduledAt', '')
  }

  const updateDateTime = (newDate: any, newTime: any) => {
    if (newDate && newTime) {
      const dateTimeString = `${newDate.format('YYYY-MM-DD')} ${newTime.format('HH:mm:ss')}`
      form.setFieldValue('scheduledAt', dateTimeString)
    } else if (newDate) {
      const dateTimeString = `${newDate.format('YYYY-MM-DD')} 12:00:00`
      form.setFieldValue('scheduledAt', dateTimeString)
    } else {
      form.setFieldValue('scheduledAt', '')
    }
  }

  const handleDateChange = (newDate: any) => {
    setDate(newDate)
    updateDateTime(newDate, time)
  }

  const handleTimeChange = (newTime: any) => {
    setTime(newTime)
    updateDateTime(date, newTime)
  }

  const disabledDate = (current: any) => {
    return current && current < moment().startOf('day')
  }
  const disabledTime = () => {
    if (!date) return {}

    const isToday = date.isSame(moment(), 'day')
    if (!isToday) return {}

    const currentHour = moment().hour()
    const currentMinute = moment().minute()

    return {
      disabledHours: () => {
        const hours = []
        for (let i = 0; i < currentHour; i++) {
          hours.push(i)
        }
        return hours
      },
      disabledMinutes: (selectedHour: number) => {
        if (selectedHour === currentHour) {
          const minutes = []
          for (let i = 0; i <= currentMinute; i++) {
            minutes.push(i)
          }
          return minutes
        }
        return []
      }
    }
  }


  return (
    <Card className="visibility-card">
      <h3 className="visibility-title required-input">Visibility</h3>

      <Form.Item className="visibility-radio" name="visibility">
        <Radio.Group
          value={publishStatus as Visibility}
          onChange={(e) => setPublishStatus(e.target.value as Visibility)}
        >
          <Radio value="public">Public</Radio>
          <Radio value="draft">Draft</Radio>
        </Radio.Group>
      </Form.Item>

      {showSchedule && (
        <>
          <Form.Item className="visibility-radio" name="scheduledAt">
            <div className="schedule-wrapper">
              <div className="field">
                <label className='date-label' >Date</label>
                <DatePicker
                  className="input"
                  value={date}
                  onChange={handleDateChange}
                  disabledDate={disabledDate}
                />
              </div>
              <div className="field">
                <label className='date-label' > Time</label>
                <TimePicker
                  className="input"
                  format="hh:mm A"
                  value={time}
                  onChange={handleTimeChange}
                  disabledTime={disabledTime}
                />
              </div>
            </div>
            <Button
              type="default"
              className="clear-date"
              onClick={handleClearDate}
            >
              Clear date
            </Button>
          </Form.Item>
        </>
      )}

      {!showSchedule && (
        <Button
          type="link"
          className="schedule-link"
          onClick={handleScheduleClick}
        >
          {publishStatus === 'draft' && (
            <span className="draft-text">Schedule Publishing Date</span>
          )}
        </Button>
      )}
    </Card>
  )
}

export default VisibilityCard
